var _path, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenanceImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 457.82 451.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-11"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.91,
    cy: 318.98,
    rx: 228.91,
    ry: 132.16,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-11"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.89,
    cy: 416.88,
    rx: 27.9,
    ry: 16.11,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.84,417.43c7.16,4.13,7.16,10.83,0,15s-18.75,4.13-25.91,0-7.15-10.83,0-15S305.69,413.3,312.84,417.43Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.29,354.58l180.21-104a21.12,21.12,0,0,1,21.14,0l44.21,26a6.9,6.9,0,0,1,0,11.95l-180.2,104a21.19,21.19,0,0,1-21.15,0l-44.21-26A6.9,6.9,0,0,1,85.29,354.58Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.72,332.64l57.53-33.44a25.6,25.6,0,0,1,25.59,0l53.48,31.39a8.35,8.35,0,0,1,0,14.46l-57.53,33.44a25.6,25.6,0,0,1-25.59,0L320.72,347.1A8.35,8.35,0,0,1,320.72,332.64Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.28,394.78l-8.7,5.05s4.39-14,2-28.11a27,27,0,0,0-3.54-9.39c-.69-1.42-5.93-10.22-1.31-14.27s15.45,4,15,25.73A84.51,84.51,0,0,1,184.28,394.78Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.28,394.78l-8.7,5.05s4.39-14,2-28.11a27,27,0,0,0-3.54-9.39c-.69-1.42-5.93-10.22-1.31-14.27s15.45,4,15,25.73A84.51,84.51,0,0,1,184.28,394.78Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.24,397.52l-.14,0a.4.4,0,0,1-.23-.51c0-.09,3.27-9.1,3.1-23.6s-7.69-22.05-7.77-22.13a.4.4,0,0,1,0-.56.4.4,0,0,1,.56,0c.08.08,7.83,7.94,8,22.68s-3.12,23.79-3.15,23.88A.4.4,0,0,1,180.24,397.52Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.53,398.72l-14.37,8.46s-6.58-1-6.08-7.17,3.17-7.65-.16-10.37-4.19-2.91-4-5.58,2-3.83,2.8-4.88,3.2-3.28,1.54-6.5-3.9-6.33-.57-7.8c2-.88,5.34.22,7.55,2.58s4,4,6.15,4.59,6.49.59,6.34,4.21-1.09,4.87-.21,6.48C178.14,385.77,185.21,387.4,177.53,398.72Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.68,402.56h0a.39.39,0,0,1-.36-.42c0-.22,1.54-21.28-13.07-35.09a.4.4,0,0,1,0-.56.38.38,0,0,1,.55,0c14.9,14.07,13.33,35.5,13.31,35.72A.38.38,0,0,1,171.68,402.56Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.1,384.19h0a.39.39,0,0,1-.36-.42,12.8,12.8,0,0,1,4.69-9.13.42.42,0,0,1,.56.09.41.41,0,0,1-.09.55,12.2,12.2,0,0,0-4.37,8.55A.39.39,0,0,1,169.1,384.19Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.16,387.85a.39.39,0,0,1-.29-.13s-3.65-3.9-11.88-2.78a.39.39,0,0,1-.1-.78c8.66-1.2,12.41,2.86,12.57,3a.41.41,0,0,1,0,.56A.39.39,0,0,1,170.16,387.85Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.5,329l-29.62,16.86a15.22,15.22,0,0,1-15.12,0l-19-11-2.16-1.25a14.83,14.83,0,0,1-7.41-12.83V266.08l44.46-25.31V296.6a12.79,12.79,0,0,0,6.39,11.08l22.48,13A4.79,4.79,0,0,1,244.5,329Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.54,347.78a15.1,15.1,0,0,0,6.34-1.94L244.5,329a4.79,4.79,0,0,0,0-8.31l-15.35-8.87H208.54Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,317l.82.65a5.65,5.65,0,0,1,2.12,4.41v2.77h-3Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.07,245v50.23A12.41,12.41,0,0,0,225.26,306L244,317a4.63,4.63,0,0,1,0,8l-2.13,1.21-26.55,15.12a14.72,14.72,0,0,1-14.63-.05l-18.42-10.87A12.38,12.38,0,0,1,176,319.72V269.49Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.07,295.23V245l-43,24.49v50.23a12.38,12.38,0,0,0,6.19,10.73l42.41-24.89A12.38,12.38,0,0,1,219.07,295.23Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.29,345.45l-4.11,2.38v7.51a14.55,14.55,0,0,1-7.49-2.07l-.32-.19a8.07,8.07,0,0,1-3.75-5.15,4.69,4.69,0,0,1-.23-1.42V336.28Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.79,69.49l-.32-.2A14.66,14.66,0,0,0,273,67.23h0a4.63,4.63,0,0,0-2.4.64l-177,101.79a14.33,14.33,0,0,0-7.16,12.4V336.28l15.89,9.17,168.16-96.67a14.33,14.33,0,0,0,7.16-12.4V76.47h7.15A8.12,8.12,0,0,0,280.79,69.49Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.92,175.64a14.35,14.35,0,0,0-1.53,6.42V336.28l15.9,9.17,5.95-3.43V188.22Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.55,340.41v10.23a4.69,4.69,0,0,0,7,4.06l177-101.79a14.33,14.33,0,0,0,7.16-12.4V230Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.76,76.06a4.69,4.69,0,0,0-7-4.06l-177,101.79a14.33,14.33,0,0,0-7.16,12.4V340.41L284.76,230",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.5,83.16h0a5.15,5.15,0,0,0-2.33.54L105.77,179.34a12.65,12.65,0,0,0-6.33,11V321.69a4.19,4.19,0,0,0,.34,1.65h0a4.15,4.15,0,0,0,5.88,1.94L272,229.64a12.66,12.66,0,0,0,6.32-11V87.29A4.14,4.14,0,0,0,274.5,83.16Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.5,83.16h0a5.15,5.15,0,0,0-2.33.54L105.77,179.34a12.65,12.65,0,0,0-6.33,11V321.69a4.19,4.19,0,0,0,.34,1.65h0a4.15,4.15,0,0,0,5.88,1.94L272,229.64a12.66,12.66,0,0,0,6.32-11V87.29A4.14,4.14,0,0,0,274.5,83.16Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.63,198.43V345.88c0,2.36.87,3.95,2.2,4.48h0l5.65,3.1,0-5,.81-151.59-7.39-3.73A12.81,12.81,0,0,0,114.63,198.43Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.9,193.12l7.39,3.73L302.07,92l4.26-2.47-5.89-3.32-.16-.1h0a3.41,3.41,0,0,0-3.53.26L120,188.27A10.85,10.85,0,0,0,115.9,193.12Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,201.64V348.12c0,2,.65,3.5,1.69,4.18l.33.19a3.48,3.48,0,0,0,3.26-.38L302.07,250.85c2.92-1.69,5.29-6.21,5.29-10.1V94.28c0-2-.61-3.4-1.58-4.11a2.06,2.06,0,0,0-.54-.3,3.5,3.5,0,0,0-3.17.42L126.32,191.55a10.64,10.64,0,0,0-3.91,4.58A12.85,12.85,0,0,0,121,201.64Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.7,188.38,200,236.73a2.78,2.78,0,0,1-4.18-2.41v-44.8a13.06,13.06,0,0,1,6.52-11.3L284.12,131a4,4,0,0,1,6,3.46v42.85A12.8,12.8,0,0,1,283.7,188.38Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.06,262.16l-10.34,6c-1.81,1.05-3.28-.06-3.28-2.48V254.89a7.88,7.88,0,0,1,3.28-6.28l10.34-6c1.81-1.05,3.28.06,3.28,2.48v10.76A7.85,7.85,0,0,1,209.06,262.16Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.28,247.68l-10.34,6c-1.81,1-3.28-.06-3.28-2.48V240.41a7.85,7.85,0,0,1,3.28-6.27l10.34-6c1.81-1,3.28.06,3.28,2.48v10.76A7.85,7.85,0,0,1,234.28,247.68Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.24,232.68l-10.34,6c-1.81,1-3.28-.06-3.28-2.48V225.4a7.88,7.88,0,0,1,3.28-6.27l10.34-6c1.81-1,3.28.07,3.28,2.49v10.76A7.85,7.85,0,0,1,260.24,232.68Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.21,217.68l-10.34,6c-1.81,1-3.28-.07-3.28-2.48V210.4a7.88,7.88,0,0,1,3.28-6.27l10.34-6c1.81-1,3.28.07,3.28,2.48v10.77A7.86,7.86,0,0,1,286.21,217.68Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.06,290.65l-10.34,6c-1.81,1-3.28-.07-3.28-2.48V283.37a7.86,7.86,0,0,1,3.28-6.27l10.34-6c1.81-1.05,3.28.07,3.28,2.48v10.77A7.88,7.88,0,0,1,209.06,290.65Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.28,276.17l-10.34,6c-1.81,1.05-3.28-.07-3.28-2.48V268.89a7.88,7.88,0,0,1,3.28-6.27l10.34-6c1.81-1,3.28.07,3.28,2.48V269.9A7.86,7.86,0,0,1,234.28,276.17Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.24,261.17l-10.34,6c-1.81,1-3.28-.07-3.28-2.48V253.89a7.86,7.86,0,0,1,3.28-6.27l10.34-6c1.81-1.05,3.28.06,3.28,2.48V254.9A7.88,7.88,0,0,1,260.24,261.17Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.21,246.16l-10.34,6c-1.81,1.05-3.28-.06-3.28-2.48V238.89a7.85,7.85,0,0,1,3.28-6.27l10.34-6c1.81-1.05,3.28.06,3.28,2.48v10.76A7.85,7.85,0,0,1,286.21,246.16Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.7,188.38,200,236.73a2.78,2.78,0,0,1-4.18-2.41v-44.8a13.06,13.06,0,0,1,6.52-11.3L284.12,131a4,4,0,0,1,6,3.46v42.85A12.8,12.8,0,0,1,283.7,188.38Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.06,262.16l-10.34,6c-1.81,1.05-3.28-.06-3.28-2.48V254.89a7.88,7.88,0,0,1,3.28-6.28l10.34-6c1.81-1.05,3.28.06,3.28,2.48v10.76A7.85,7.85,0,0,1,209.06,262.16Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.28,247.68l-10.34,6c-1.81,1-3.28-.06-3.28-2.48V240.41a7.85,7.85,0,0,1,3.28-6.27l10.34-6c1.81-1,3.28.06,3.28,2.48v10.76A7.85,7.85,0,0,1,234.28,247.68Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.24,232.68l-10.34,6c-1.81,1-3.28-.06-3.28-2.48V225.4a7.88,7.88,0,0,1,3.28-6.27l10.34-6c1.81-1,3.28.07,3.28,2.49v10.76A7.85,7.85,0,0,1,260.24,232.68Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.21,217.68l-10.34,6c-1.81,1-3.28-.07-3.28-2.48V210.4a7.88,7.88,0,0,1,3.28-6.27l10.34-6c1.81-1,3.28.07,3.28,2.48v10.77A7.86,7.86,0,0,1,286.21,217.68Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.06,290.65l-10.34,6c-1.81,1-3.28-.07-3.28-2.48V283.37a7.86,7.86,0,0,1,3.28-6.27l10.34-6c1.81-1.05,3.28.07,3.28,2.48v10.77A7.88,7.88,0,0,1,209.06,290.65Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.28,276.17l-10.34,6c-1.81,1.05-3.28-.07-3.28-2.48V268.89a7.88,7.88,0,0,1,3.28-6.27l10.34-6c1.81-1,3.28.07,3.28,2.48V269.9A7.86,7.86,0,0,1,234.28,276.17Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.24,261.17l-10.34,6c-1.81,1-3.28-.07-3.28-2.48V253.89a7.86,7.86,0,0,1,3.28-6.27l10.34-6c1.81-1.05,3.28.06,3.28,2.48V254.9A7.88,7.88,0,0,1,260.24,261.17Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.21,246.16l-10.34,6c-1.81,1.05-3.28-.06-3.28-2.48V238.89a7.85,7.85,0,0,1,3.28-6.27l10.34-6c1.81-1.05,3.28.06,3.28,2.48v10.76A7.85,7.85,0,0,1,286.21,246.16Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M179.76,321.48,126,352.5a3.46,3.46,0,0,1-5.2-3V205l58.93-34Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.76,321.48,126,352.5a3.46,3.46,0,0,1-5.2-3V205l58.93-34Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.09,214.54a9,9,0,0,1-4.07,7c-2.24,1.3-4.06.25-4.06-2.34a9,9,0,0,1,4.06-7C135.27,210.9,137.09,212,137.09,214.54Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.09,230.11a9,9,0,0,1-4.07,7c-2.24,1.3-4.06.25-4.06-2.34a9,9,0,0,1,4.06-7.05C135.27,226.47,137.09,227.52,137.09,230.11Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.09,245.68a9,9,0,0,1-4.07,7c-2.24,1.3-4.06.25-4.06-2.35a9,9,0,0,1,4.06-7C135.27,242,137.09,243.09,137.09,245.68Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.09,261.25a9,9,0,0,1-4.07,7c-2.24,1.3-4.06.24-4.06-2.35a9,9,0,0,1,4.06-7C135.27,257.6,137.09,258.65,137.09,261.25Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.15,210.79a1.47,1.47,0,0,1-.74-2.75l23.82-13.75a1.47,1.47,0,0,1,1.47,2.55l-23.82,13.75A1.49,1.49,0,0,1,146.15,210.79Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.15,226.36a1.47,1.47,0,0,1-.74-2.75l23.82-13.76a1.48,1.48,0,0,1,2,.54,1.46,1.46,0,0,1-.54,2l-23.82,13.76A1.49,1.49,0,0,1,146.15,226.36Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.15,241.92a1.47,1.47,0,0,1-.74-2.74l23.82-13.76a1.48,1.48,0,0,1,2,.54,1.46,1.46,0,0,1-.54,2l-23.82,13.76A1.47,1.47,0,0,1,146.15,241.92Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.15,257.49a1.47,1.47,0,0,1-.74-2.75L169.23,241a1.48,1.48,0,0,1,2,.54,1.46,1.46,0,0,1-.54,2l-23.82,13.75A1.39,1.39,0,0,1,146.15,257.49Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,294a1.47,1.47,0,0,1-.74-2.75l36.94-21.32a1.47,1.47,0,1,1,1.47,2.54l-36.94,21.33A1.39,1.39,0,0,1,133,294Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,307a1.47,1.47,0,0,1-.74-2.75l36.94-21.33a1.48,1.48,0,0,1,2,.54,1.46,1.46,0,0,1-.54,2l-36.94,21.33A1.39,1.39,0,0,1,133,307Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,320a1.47,1.47,0,0,1-.74-2.75l36.94-21.33a1.48,1.48,0,0,1,2,.54,1.46,1.46,0,0,1-.54,2l-36.94,21.33A1.49,1.49,0,0,1,133,320Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,332.94a1.47,1.47,0,0,1-.74-2.75l36.94-21.33a1.47,1.47,0,0,1,1.47,2.55l-36.94,21.33A1.49,1.49,0,0,1,133,332.94Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,287.49a.47.47,0,0,1-.42-.24.49.49,0,0,1,.17-.67l57.22-33a.48.48,0,0,1,.67.18.5.5,0,0,1-.18.67l-57.21,33A.57.57,0,0,1,121,287.49Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.14,192.55l177.91-103a3.14,3.14,0,0,1,4.73,2.71V100L120.83,207.7v-6.06C120.83,198.54,122.47,194.11,125.14,192.55Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.87,89.94a2,2,0,0,1,.76.15,1.17,1.17,0,0,1,.33.2,4.17,4.17,0,0,1,1.23,3.41V241.06c0,3.56-2.23,7.86-4.88,9.38L125.51,352.32a3.37,3.37,0,0,1-1.66.51,1.83,1.83,0,0,1-.77-.16l-.28-.15c-.81-.56-1.27-1.81-1.27-3.45V201.71a12.09,12.09,0,0,1,1.29-5.16,9.79,9.79,0,0,1,3.58-4.22L303.2,90.46a3.35,3.35,0,0,1,1.67-.52m0-.89a4.29,4.29,0,0,0-2.11.63L126,191.56a10.69,10.69,0,0,0-3.94,4.6,12.92,12.92,0,0,0-1.38,5.55V349.07c0,2.05.65,3.52,1.7,4.21l.34.19a2.71,2.71,0,0,0,1.17.26,4.29,4.29,0,0,0,2.11-.64l176.8-101.87c2.94-1.7,5.32-6.25,5.32-10.16V93.7c0-2-.61-3.41-1.59-4.13a2.23,2.23,0,0,0-.54-.31,2.74,2.74,0,0,0-1.08-.21Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Crane--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "333.61 196.09 333.61 200.74 354.18 193.32 370.36 159.24 362.77 158.23 349.09 186.69 333.61 196.09",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.61 196.09 338.7 198.73 338.7 203.38 333.61 200.74 333.61 196.09",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.7 198.73 338.7 203.38 356.22 193.32 371.32 160.91 367.87 160.87 354.18 189.33 338.7 198.73",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.87 228 408.7 168.1 418.7 172.06 394.38 235.39 378.87 228",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.79,170.93h0c-1.72-1-4.11-.86-6.74.66-5.25,3-9.51,10.4-9.51,16.47,0,3.31,1.28,5.54,3.29,6.39h0L438.07,201l13.41-23.29Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 445.03,
    cy: 189.48,
    rx: 13.45,
    ry: 7.77,
    transform: "translate(37.33 455.72) rotate(-60)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 445.03,
    cy: 189.48,
    rx: 13.45,
    ry: 7.77,
    transform: "translate(37.33 455.72) rotate(-60)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.85,186.7a10.69,10.69,0,0,1-4.82,8.36c-2.67,1.54-4.83.29-4.83-2.79a10.66,10.66,0,0,1,4.83-8.36C447.69,182.37,449.85,183.62,449.85,186.7Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.85,186.7a10.69,10.69,0,0,1-4.82,8.36c-2.67,1.54-4.83.29-4.83-2.79a10.66,10.66,0,0,1,4.83-8.36C447.69,182.37,449.85,183.62,449.85,186.7Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.22,181.4c.35.57,38,8.08,38,8.08s3.52-.53,3.52-3.85a4.51,4.51,0,0,0-3.17-4.23L394,176.53Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.42,167.55h0c-1.19-.69-2.84-.59-4.66.46a14.52,14.52,0,0,0-6.58,11.39c0,2.29.89,3.83,2.28,4.42h0l7.78,4.51,9.27-16.1Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.62,176.59A14.52,14.52,0,0,1,394,188c-3.63,2.1-6.58.4-6.58-3.79A14.55,14.55,0,0,1,394,172.79C397.67,170.69,400.62,172.39,400.62,176.59Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.62,176.59A14.52,14.52,0,0,1,394,188c-3.63,2.1-6.58.4-6.58-3.79A14.55,14.55,0,0,1,394,172.79C397.67,170.69,400.62,172.39,400.62,176.59Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.38,178.46a7.41,7.41,0,0,1-3.34,5.78c-1.84,1.06-3.34.2-3.34-1.93a7.38,7.38,0,0,1,3.34-5.78C395.88,175.46,397.38,176.33,397.38,178.46Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.38,178.46a7.41,7.41,0,0,1-3.34,5.78c-1.84,1.06-3.34.2-3.34-1.93a7.38,7.38,0,0,1,3.34-5.78C395.88,175.46,397.38,176.33,397.38,178.46Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 335.17,
    cy: 321.91,
    rx: 25.21,
    ry: 14.55,
    transform: "translate(-93.86 520.07) rotate(-72.46)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.18 320.97 317.71 328.7 336.55 282.29 335.1 281.31 305.18 320.97",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 347.97,
    cy: 329.78,
    rx: 25.21,
    ry: 14.55,
    transform: "translate(-92.42 537.77) rotate(-72.46)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 422.76,
    cy: 321.33,
    rx: 24.38,
    ry: 14.55,
    transform: "translate(-32.11 603.18) rotate(-72.46)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.37 319.31 405.63 327.54 423.41 280.42 410.46 274.25 392.37 319.31",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.97 228 372.13 255.35 408.7 234.07 361.05 206.8 323.97 228",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.7 234.07 396.21 241.34 396.2 241.34 394.34 242.43 372.13 255.35 323.96 228 346.69 215.01 348.44 214 361.05 206.8 408.7 234.07",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.79,258.5v63.68l-12.49,7.25-1.74,1-12,6.94c-3-9.59-11.24-11.66-19.15-4.42a33.94,33.94,0,0,0-7.85,11.48V329.58l16.62-49.8,22.21-12.92,1.86-1.09h0Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.79,258.5v63.68l-12.49,7.25-1.74,1-12,6.94c-3-9.59-11.24-11.66-19.15-4.42a33.94,33.94,0,0,0-7.85,11.48V329.58l16.62-49.8,22.21-12.92,1.86-1.09h0Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.35 277.8 355.51 305.15 355.51 320.01 345.56 314.58 345.56 330.3 316.71 313.76 316.71 297.93 307.35 292.65 307.35 277.8",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.97 228 307.35 277.8 355.51 305.15 372.13 255.35 323.97 228",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.97 228 307.35 277.8 355.51 305.15 372.13 255.35 323.97 228",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.6,344.44,366.66,339c-3.17,6.28-4.87,13.41-4.27,19.59,1.11,11.31,9.5,15.12,18.74,8.51,6.44-4.61,11.58-13.05,13.74-21.58Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.77 344.7 360.03 352.93 378.87 306.53 377.43 305.54 346.77 344.7",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 388.89,
    cy: 353.06,
    rx: 25.21,
    ry: 14.55,
    transform: "translate(-86.03 593.05) rotate(-72.46)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 390.29,
    cy: 354.02,
    rx: 25.21,
    ry: 14.55,
    transform: "translate(-85.96 595.06) rotate(-72.46)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 391.34,
    cy: 354.73,
    rx: 11.38,
    ry: 6.57,
    transform: "translate(-85.91 596.55) rotate(-72.46)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.9,349.15a17.34,17.34,0,0,1-4.22,13.34c-3,3.09-6.08,2.12-6.79-2.15A17.32,17.32,0,0,1,390.1,347C393.14,343.91,396.18,344.87,396.9,349.15Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.11,350.87a12.41,12.41,0,0,1-2.84,9c-2,2.11-3.9,1.51-4.31-1.36a12.42,12.42,0,0,1,2.85-9C392.78,347.4,394.71,348,395.11,350.87Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 434.48,
    cy: 327.66,
    rx: 25.21,
    ry: 14.55,
    transform: "translate(-29.96 618.79) rotate(-72.46)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 435.89,
    cy: 328.62,
    rx: 25.21,
    ry: 14.55,
    transform: "translate(-29.9 620.8) rotate(-72.46)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.79,323.06a17.84,17.84,0,0,1-4.85,15.35c-3.79,3.46-7.75,2.21-8.86-2.8s1.06-11.88,4.85-15.35S442.68,318.05,443.79,323.06Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 436.99,
    cy: 329.35,
    rx: 9.89,
    ry: 5.04,
    transform: "translate(-29.82 622.35) rotate(-72.46)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.71,325.47a12.38,12.38,0,0,1-2.85,9c-2,2.11-3.9,1.5-4.3-1.36a12.37,12.37,0,0,1,2.85-9C438.38,322,440.31,322.61,440.71,325.47Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.05 257.12 359.97 278.31 358.13 283.83 354.37 295.11 353.04 299.09 346.35 295.3 312.44 276.04 326.45 234.05 332.17 237.3 341.52 242.62 349.09 246.92 352.8 249.03 367.05 257.12",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.3,265.77v63.66l-1.74,1a.89.89,0,0,1-.13-.47V266.86l-47.3-27.08a.88.88,0,0,1-.35-.34l1.75-1,47.76,27.34Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M417.3,265.77v63.66l-1.74,1a.89.89,0,0,1-.13-.47V266.86l-47.3-27.08a.88.88,0,0,1-.35-.34l1.75-1,47.76,27.34Z",
    transform: "translate(-21.09 -24.43)"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "354.37 295.11 353.04 299.09 346.35 295.3 332.17 237.3 341.52 242.62 354.37 295.11",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.97 278.31 358.13 283.83 349.09 246.92 352.8 249.03 359.97 278.31",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.31 283.46 359.97 302.12 374.52 258.53 391.31 248.76 391.31 283.46",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.73 275.09 399.49 278.69 399.49 243.92 405.73 240.31 405.73 275.09",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.79,199.25v63a1.91,1.91,0,0,0,.94,1.92h0l2.41,1.33v-2.15l.34-64.8-3.16-1.6A5.51,5.51,0,0,0,279.79,199.25Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.33,197l3.16,1.6,76.42-44.8,1.82-1.06-2.51-1.42-.08,0h0a1.43,1.43,0,0,0-1.5.11l-75.58,43.54A4.74,4.74,0,0,0,280.33,197Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.33,197l3.16,1.6,76.42-44.8,1.82-1.06-2.51-1.42-.08,0h0a1.43,1.43,0,0,0-1.5.11l-75.58,43.54A4.74,4.74,0,0,0,280.33,197Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.53,200.63v62.61a2.07,2.07,0,0,0,.72,1.79l.15.08a1.49,1.49,0,0,0,1.39-.16l75.12-43.29a5.4,5.4,0,0,0,2.26-4.31V154.74a2.11,2.11,0,0,0-.67-1.76,1,1,0,0,0-.23-.13,1.53,1.53,0,0,0-1.36.18l-75.12,43.28a4.53,4.53,0,0,0-1.67,2A5.42,5.42,0,0,0,282.53,200.63Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.53,200.63v62.61a2.07,2.07,0,0,0,.72,1.79l.15.08a1.49,1.49,0,0,0,1.39-.16l75.12-43.29a5.4,5.4,0,0,0,2.26-4.31V154.74a2.11,2.11,0,0,0-.67-1.76,1,1,0,0,0-.23-.13,1.53,1.53,0,0,0-1.36.18l-75.12,43.28a4.53,4.53,0,0,0-1.67,2A5.42,5.42,0,0,0,282.53,200.63Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.87, -0.5, 0, 1, 274.99, 216.77)",
    style: {
      fontSize: "42.409053802490234px",
      fill: "#fafafa",
      fontFamily: "Montserrat-Bold, Montserrat",
      fontWeight: 700
    }
  }, "/"), /*#__PURE__*/React.createElement("path", {
    d: "M361.11,152.88a.71.71,0,0,1,.32.07.37.37,0,0,1,.15.08,1.8,1.8,0,0,1,.52,1.46v63a5.1,5.1,0,0,1-2.08,4L284.44,265a1.41,1.41,0,0,1-.71.23.79.79,0,0,1-.32-.07l-.12-.06a1.73,1.73,0,0,1-.55-1.48v-63a5.26,5.26,0,0,1,.55-2.21,4.28,4.28,0,0,1,1.53-1.8L360.4,153.1a1.49,1.49,0,0,1,.71-.22m0-.38a1.85,1.85,0,0,0-.9.27l-75.58,43.55a4.47,4.47,0,0,0-1.68,2,5.43,5.43,0,0,0-.59,2.37v63a2.1,2.1,0,0,0,.72,1.8l.15.08a1.18,1.18,0,0,0,.5.11,1.77,1.77,0,0,0,.9-.28l75.58-43.54a5.46,5.46,0,0,0,2.27-4.34v-63a2.12,2.12,0,0,0-.68-1.77,1,1,0,0,0-.23-.13,1.18,1.18,0,0,0-.46-.09Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "346.06 124.84 363.51 146.99 367.75 149.27 349.81 122.71 346.06 124.84",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.53 131.38 334.53 134.85 350.49 125.76 367.75 149.27 369.67 147.34 351.37 121.83 334.53 131.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.37 121.83 345.56 118.3 328.72 128.02 334.53 131.38 351.37 121.83",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.72 128.02 328.72 131.38 334.53 134.85 334.53 131.38 328.72 128.02",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.84,342.78a1.41,1.41,0,0,1-.71-.2l-15.66-9a3.89,3.89,0,0,1-1.94-3.37V318.6a1.39,1.39,0,0,1,.71-1.23,1.41,1.41,0,0,1,1.43,0l15.65,9a3.9,3.9,0,0,1,1.95,3.37v11.57a1.42,1.42,0,0,1-.71,1.23A1.45,1.45,0,0,1,359.84,342.78Zm-.28-.93a.58.58,0,0,0,.86-.5V329.78a3,3,0,0,0-1.52-2.63l-15.66-9a.56.56,0,0,0-.57,0,.58.58,0,0,0-.29.5v11.57a3.06,3.06,0,0,0,1.52,2.64Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.96,
    y: 314.27,
    width: 0.85,
    height: 21.8,
    transform: "translate(-127 442.47) rotate(-60)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.96,
    y: 317.47,
    width: 0.85,
    height: 21.8,
    transform: "translate(-129.77 444.09) rotate(-60)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.96,
    y: 320.68,
    width: 0.85,
    height: 21.8,
    transform: "translate(-132.55 445.67) rotate(-60)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.96,
    y: 323.88,
    width: 0.85,
    height: 21.8,
    transform: "translate(-135.32 447.28) rotate(-60)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.05 291.66 307.35 287.79 307.35 283.83 314.05 287.7 314.05 291.66",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.51 314.97 348.81 311.1 348.81 307.15 355.51 311.01 355.51 314.97",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,133.47v34.66a1.06,1.06,0,0,0,.52,1.06h0l1.32.73v-1.18L301,133.1l-1.74-.87A2.9,2.9,0,0,0,299,133.47Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.29,132.23l1.74.87,42-24.63,1-.58-1.38-.78,0,0h0a.81.81,0,0,0-.83.06l-41.56,24A2.54,2.54,0,0,0,299.29,132.23Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.29,132.23l1.74.87,42-24.63,1-.58-1.38-.78,0,0h0a.81.81,0,0,0-.83.06l-41.56,24A2.54,2.54,0,0,0,299.29,132.23Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.5,134.23v34.43a1.13,1.13,0,0,0,.39,1l.08.05a.84.84,0,0,0,.77-.09l41.31-23.8a3,3,0,0,0,1.24-2.38V109a1.15,1.15,0,0,0-.37-1,.37.37,0,0,0-.12-.07.83.83,0,0,0-.75.09l-41.31,23.81a2.51,2.51,0,0,0-.92,1.07A3,3,0,0,0,300.5,134.23Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.5,134.23v34.43a1.13,1.13,0,0,0,.39,1l.08.05a.84.84,0,0,0,.77-.09l41.31-23.8a3,3,0,0,0,1.24-2.38V109a1.15,1.15,0,0,0-.37-1,.37.37,0,0,0-.12-.07.83.83,0,0,0-.75.09l-41.31,23.81a2.51,2.51,0,0,0-.92,1.07A3,3,0,0,0,300.5,134.23Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.87, -0.5, 0, 1, 285.61, 130.33)",
    style: {
      fontSize: "18.2454833984375px",
      fill: "#fafafa",
      fontFamily: "Montserrat-Bold, Montserrat",
      fontWeight: 700
    }
  }, "C++"), /*#__PURE__*/React.createElement("path", {
    d: "M343.71,108a.39.39,0,0,1,.18,0l.08,0a1,1,0,0,1,.28.81v34.63a2.81,2.81,0,0,1-1.14,2.21l-41.56,24a.79.79,0,0,1-.39.12.48.48,0,0,1-.18,0l-.06,0a1,1,0,0,1-.31-.82V134.25a2.79,2.79,0,0,1,.31-1.22,2.21,2.21,0,0,1,.84-1l41.56-23.95a.79.79,0,0,1,.39-.12m0-.21a1.05,1.05,0,0,0-.5.15l-41.56,24a2.55,2.55,0,0,0-.92,1.08,3.06,3.06,0,0,0-.33,1.31v34.63a1.14,1.14,0,0,0,.4,1l.08,0a.67.67,0,0,0,.28.06,1,1,0,0,0,.49-.15l41.56-24a3,3,0,0,0,1.25-2.39V108.86a1.14,1.14,0,0,0-.37-1,.57.57,0,0,0-.13-.08.7.7,0,0,0-.25,0Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299,79.69v34.53c0,.55.2.93.52,1h0l1.32.73v-1.18l.19-35.5-1.73-.87A2.9,2.9,0,0,0,299,79.69Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.29,78.45l1.73.87,41.87-24.54,1-.58-1.38-.78,0,0h0a.77.77,0,0,0-.83.06l-41.4,23.85A2.59,2.59,0,0,0,299.29,78.45Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.29,78.45l1.73.87,41.87-24.54,1-.58-1.38-.78,0,0h0a.77.77,0,0,0-.83.06l-41.4,23.85A2.59,2.59,0,0,0,299.29,78.45Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.49,80.44v34.3a1.14,1.14,0,0,0,.4,1l.08,0a.8.8,0,0,0,.76-.09L342.89,92a3,3,0,0,0,1.23-2.37V55.3a1.15,1.15,0,0,0-.37-1l-.12-.07a.81.81,0,0,0-.74.1L301.73,78.08a2.58,2.58,0,0,0-.92,1.07A3,3,0,0,0,300.49,80.44Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.49,80.44v34.3a1.14,1.14,0,0,0,.4,1l.08,0a.8.8,0,0,0,.76-.09L342.89,92a3,3,0,0,0,1.23-2.37V55.3a1.15,1.15,0,0,0-.37-1l-.12-.07a.81.81,0,0,0-.74.1L301.73,78.08a2.58,2.58,0,0,0-.92,1.07A3,3,0,0,0,300.49,80.44Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.87, -0.5, 0, 1, 288.92, 75.11)",
    style: {
      fontSize: "23.233461380004883px",
      fill: "#fafafa",
      fontFamily: "Montserrat-Bold, Montserrat",
      fontWeight: 700
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    xmlSpace: "preserve"
  }, "{}"))), /*#__PURE__*/React.createElement("path", {
    d: "M343.54,54.29a.57.57,0,0,1,.18,0l.08,0a1,1,0,0,1,.28.8v34.5a2.79,2.79,0,0,1-1.14,2.2l-41.4,23.86a.79.79,0,0,1-.39.12.29.29,0,0,1-.17,0l-.07,0a1,1,0,0,1-.3-.81V80.46a2.77,2.77,0,0,1,.3-1.21,2.33,2.33,0,0,1,.84-1l41.4-23.85a.79.79,0,0,1,.39-.12m0-.21a.9.9,0,0,0-.49.15L301.64,78.08a2.55,2.55,0,0,0-.92,1.08,3,3,0,0,0-.32,1.3V115a1.11,1.11,0,0,0,.4,1l.08,0a.6.6,0,0,0,.27.06,1,1,0,0,0,.49-.15l41.41-23.86a3,3,0,0,0,1.24-2.38V55.17a1.16,1.16,0,0,0-.37-1,.33.33,0,0,0-.13-.07.51.51,0,0,0-.25-.05Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.4,80.58a4.32,4.32,0,0,1,1.22-2.69l3.9-3.94a2.48,2.48,0,0,0,.68-2.27l-1-4.76a1,1,0,0,0-.5-.66h0l-5.52-2.7-.13-.07a1,1,0,0,0-1,.15L213.47,65l1.64-5a1.24,1.24,0,0,0-.63-1.5h0L209,55.77h0a1.26,1.26,0,0,0-.44-.14L205,55.17a1.68,1.68,0,0,0-1.35.44h0a1.56,1.56,0,0,0-.4.55l-2.63,6a3.09,3.09,0,0,1-1.21,1.39l-.18-.49a1,1,0,0,0-.49-.52h0l-5.43-2.65-.17-.08h0a.92.92,0,0,0-1,.21l-4.65,4.7a3,3,0,0,0-.71,1.17,2.9,2.9,0,0,0-.09,1.28l.67,4.28A2.2,2.2,0,0,1,187,73l-2.65,4.12a2.08,2.08,0,0,1-.57.61,2.24,2.24,0,0,1-1.28.41h-3a2,2,0,0,0-.54.07,2.09,2.09,0,0,0-1.41,1.29l-2.66,7.28a1.12,1.12,0,0,0,.5,1.37h0l3.94,1.93a1.33,1.33,0,0,1,0,.53l-.44,4.08a2.45,2.45,0,0,1-.2.75,2.73,2.73,0,0,1-.59.92l-4,4.16a2.59,2.59,0,0,0-.61,1,2.52,2.52,0,0,0,0,1.28L174.6,108a.76.76,0,0,0,.43.52h0l5.5,2.69h0a.74.74,0,0,0,.84-.08l1.79-1.47-1.5,5.18a1,1,0,0,0,0,.35h0a1.18,1.18,0,0,0,.69,1v0l5.35,2.6h0a1,1,0,0,0,.55.22l3.09.39a1.94,1.94,0,0,0,2-1.13l2.63-5.88a3.1,3.1,0,0,1,1.28-1.4l.14.39a.91.91,0,0,0,.56.56h0l5.43,2.66,0,0h0a.93.93,0,0,0,1-.16l4.73-4.33a2.36,2.36,0,0,0,.74-2.07l-.67-4.73a3.36,3.36,0,0,1,.51-2.29l2.16-3.35a3.05,3.05,0,0,1,2.55-1.39h2.88A1.71,1.71,0,0,0,219,95.24l2.62-7a1.43,1.43,0,0,0-.62-1.72h0l0,0-.11,0-3.62-1.77a1.41,1.41,0,0,1,0-.46ZM200,77.19a9.36,9.36,0,0,1,3.88-1.7,10,10,0,0,1,1,3.79c.59,6.34-3.14,14.46-8.34,18.15a10.09,10.09,0,0,1-3.81,1.75,9.66,9.66,0,0,1-1.1-3.85C191.11,89,194.84,80.87,200,77.19Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.4,80.58a4.32,4.32,0,0,1,1.22-2.69l3.9-3.94a2.48,2.48,0,0,0,.68-2.27l-1-4.76a1,1,0,0,0-.5-.66h0l-5.52-2.7-.13-.07a1,1,0,0,0-1,.15L213.47,65l1.64-5a1.24,1.24,0,0,0-.63-1.5h0L209,55.77h0a1.26,1.26,0,0,0-.44-.14L205,55.17a1.68,1.68,0,0,0-1.35.44h0a1.56,1.56,0,0,0-.4.55l-2.63,6a3.09,3.09,0,0,1-1.21,1.39l-.18-.49a1,1,0,0,0-.49-.52h0l-5.43-2.65-.17-.08h0a.92.92,0,0,0-1,.21l-4.65,4.7a3,3,0,0,0-.71,1.17,2.9,2.9,0,0,0-.09,1.28l.67,4.28A2.2,2.2,0,0,1,187,73l-2.65,4.12a2.08,2.08,0,0,1-.57.61,2.24,2.24,0,0,1-1.28.41h-3a2,2,0,0,0-.54.07,2.09,2.09,0,0,0-1.41,1.29l-2.66,7.28a1.12,1.12,0,0,0,.5,1.37h0l3.94,1.93a1.33,1.33,0,0,1,0,.53l-.44,4.08a2.45,2.45,0,0,1-.2.75,2.73,2.73,0,0,1-.59.92l-4,4.16a2.59,2.59,0,0,0-.61,1,2.52,2.52,0,0,0,0,1.28L174.6,108a.76.76,0,0,0,.43.52h0l5.5,2.69h0a.74.74,0,0,0,.84-.08l1.79-1.47-1.5,5.18a1,1,0,0,0,0,.35h0a1.18,1.18,0,0,0,.69,1v0l5.35,2.6h0a1,1,0,0,0,.55.22l3.09.39a1.94,1.94,0,0,0,2-1.13l2.63-5.88a3.1,3.1,0,0,1,1.28-1.4l.14.39a.91.91,0,0,0,.56.56h0l5.43,2.66,0,0h0a.93.93,0,0,0,1-.16l4.73-4.33a2.36,2.36,0,0,0,.74-2.07l-.67-4.73a3.36,3.36,0,0,1,.51-2.29l2.16-3.35a3.05,3.05,0,0,1,2.55-1.39h2.88A1.71,1.71,0,0,0,219,95.24l2.62-7a1.43,1.43,0,0,0-.62-1.72h0l0,0-.11,0-3.62-1.77a1.41,1.41,0,0,1,0-.46ZM200,77.19a9.36,9.36,0,0,1,3.88-1.7,10,10,0,0,1,1,3.79c.59,6.34-3.14,14.46-8.34,18.15a10.09,10.09,0,0,1-3.81,1.75,9.66,9.66,0,0,1-1.1-3.85C191.11,89,194.84,80.87,200,77.19Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,98.29l-6,6.08-5.53-2.85a2.59,2.59,0,0,1,.61-1l4-4.16a2.73,2.73,0,0,0,.59-.92Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.36,80.4l-.12.68h-5.19L179,78.17a2,2,0,0,1,.54-.07h3a2.24,2.24,0,0,0,1.28-.41Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.72,62.54l-2.34,2.3h0l-4.14,4.08-5.48-3h0a3,3,0,0,1,.71-1.17l4.65-4.7a.92.92,0,0,1,1-.21h0l.17.08Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.5,58.47h-5.45l-5.42-2.86h0a1.68,1.68,0,0,1,1.35-.44l3.55.45a1.26,1.26,0,0,1,.44.14h0Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.62,77.89l3.9-3.94a2.48,2.48,0,0,0,.68-2.27l-1-4.76a1,1,0,0,0-1.57-.56l-4,3.33a1.08,1.08,0,0,1-1.47-.08L214,68.4a2.88,2.88,0,0,1-.66-2.89L215.11,60a1.25,1.25,0,0,0-1-1.63l-3.54-.44a1.67,1.67,0,0,0-1.75,1l-2.63,6a3.13,3.13,0,0,1-1.64,1.62l-2.36,1a1.12,1.12,0,0,1-1.48-.63l-1.47-3.81a.93.93,0,0,0-1.54-.32L193,67.43a2.88,2.88,0,0,0-.79,2.45l.67,4.28a2.2,2.2,0,0,1-.33,1.52l-2.64,4.13a2.21,2.21,0,0,1-1.86,1h-3a2.08,2.08,0,0,0-2,1.37l-2.67,7.27a1.14,1.14,0,0,0,.74,1.47l2.76.83a1.44,1.44,0,0,1,1,1.54l-.44,4.08a2.84,2.84,0,0,1-.79,1.67l-4,4.17a2.53,2.53,0,0,0-.66,2.3l1.15,5.18a.75.75,0,0,0,1.21.42l4-3.27a1.54,1.54,0,0,1,2.18.21l1,1.23a2.39,2.39,0,0,1,.44,2.17l-1.76,6.09a1.17,1.17,0,0,0,1,1.5l3.09.39a1.94,1.94,0,0,0,2-1.13l2.63-5.88a3.06,3.06,0,0,1,1.49-1.52l2.3-1.1a1.43,1.43,0,0,1,2,.82l1.23,3.51a.93.93,0,0,0,1.51.38l4.73-4.33a2.36,2.36,0,0,0,.74-2.07l-.67-4.73a3.36,3.36,0,0,1,.51-2.29l2.16-3.35a3.05,3.05,0,0,1,2.55-1.39h2.88A1.71,1.71,0,0,0,219,95.24l2.62-7a1.44,1.44,0,0,0-1-1.88l-2.38-.64a1.45,1.45,0,0,1-1.07-1.5l.25-3.59A4.32,4.32,0,0,1,218.62,77.89Zm-16.45,22.26c-5.19,3.68-9.88,1.52-10.47-4.82s3.14-14.46,8.33-18.14,9.89-1.52,10.48,4.82S207.36,96.47,202.17,100.15Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,164.76a7.32,7.32,0,0,1,2.11-4.66l6.76-6.82a4.4,4.4,0,0,0,1.17-3.95l-1.71-8.24a1.66,1.66,0,0,0-.87-1.14h0l-9.58-4.67-.23-.12a1.65,1.65,0,0,0-1.69.26l-2.79,2.3,2.85-8.66a2.15,2.15,0,0,0-1.1-2.6h0l-9.56-4.68h0a2,2,0,0,0-.76-.25l-6.15-.78a2.89,2.89,0,0,0-2.34.75h0a2.74,2.74,0,0,0-.69,1l-4.56,10.39a5.27,5.27,0,0,1-2.09,2.41l-.32-.85a1.65,1.65,0,0,0-.85-.89h0l-9.4-4.6-.3-.14h0a1.61,1.61,0,0,0-1.74.36l-8.06,8.15a5.08,5.08,0,0,0-1.22,2,5.14,5.14,0,0,0-.16,2.21l1.16,7.42a3.8,3.8,0,0,1-.56,2.63l-4.59,7.15a3.55,3.55,0,0,1-1,1.05,3.76,3.76,0,0,1-2.21.71H42.32a3.17,3.17,0,0,0-.93.13,3.58,3.58,0,0,0-2.45,2.23l-4.62,12.61a2,2,0,0,0,.88,2.37h0l0,0,6.82,3.34a2.35,2.35,0,0,1,.07.92l-.76,7.07a5,5,0,0,1-.35,1.31A4.82,4.82,0,0,1,40,192l-7,7.22a4.43,4.43,0,0,0-1.13,4l2,9a1.31,1.31,0,0,0,.76.91h0l9.53,4.66h0a1.31,1.31,0,0,0,1.46-.13l3.09-2.55-2.59,9a1.61,1.61,0,0,0-.08.61h0a2.06,2.06,0,0,0,1.18,1.81l0,0,9.27,4.5h0a2,2,0,0,0,1,.39l5.36.67a3.38,3.38,0,0,0,3.5-2l4.56-10.18a5.31,5.31,0,0,1,2.22-2.42l.23.67a1.61,1.61,0,0,0,1,1h0l9.42,4.62,0,0,0,0h0a1.6,1.6,0,0,0,1.77-.27l8.2-7.5A4.13,4.13,0,0,0,95,212.48l-1.17-8.2a5.85,5.85,0,0,1,.88-4l3.75-5.8a5.25,5.25,0,0,1,4.41-2.4h5a3,3,0,0,0,2.8-2L115.22,178a2.48,2.48,0,0,0-1.08-3h0l-.06,0-.18-.09-6.28-3.06a2.43,2.43,0,0,1-.08-.81Zm-30.1-5.87a16.41,16.41,0,0,1,6.71-3,17.32,17.32,0,0,1,1.81,6.59c1,11-5.45,25-14.45,31.43a17.25,17.25,0,0,1-6.6,3,16.77,16.77,0,0,1-1.91-6.66C62.44,179.34,68.91,165.27,77.91,158.89Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,164.76a7.32,7.32,0,0,1,2.11-4.66l6.76-6.82a4.4,4.4,0,0,0,1.17-3.95l-1.71-8.24a1.66,1.66,0,0,0-.87-1.14h0l-9.58-4.67-.23-.12a1.65,1.65,0,0,0-1.69.26l-2.79,2.3,2.85-8.66a2.15,2.15,0,0,0-1.1-2.6h0l-9.56-4.68h0a2,2,0,0,0-.76-.25l-6.15-.78a2.89,2.89,0,0,0-2.34.75h0a2.74,2.74,0,0,0-.69,1l-4.56,10.39a5.27,5.27,0,0,1-2.09,2.41l-.32-.85a1.65,1.65,0,0,0-.85-.89h0l-9.4-4.6-.3-.14h0a1.61,1.61,0,0,0-1.74.36l-8.06,8.15a5.08,5.08,0,0,0-1.22,2,5.14,5.14,0,0,0-.16,2.21l1.16,7.42a3.8,3.8,0,0,1-.56,2.63l-4.59,7.15a3.55,3.55,0,0,1-1,1.05,3.76,3.76,0,0,1-2.21.71H42.32a3.17,3.17,0,0,0-.93.13,3.58,3.58,0,0,0-2.45,2.23l-4.62,12.61a2,2,0,0,0,.88,2.37h0l0,0,6.82,3.34a2.35,2.35,0,0,1,.07.92l-.76,7.07a5,5,0,0,1-.35,1.31A4.82,4.82,0,0,1,40,192l-7,7.22a4.43,4.43,0,0,0-1.13,4l2,9a1.31,1.31,0,0,0,.76.91h0l9.53,4.66h0a1.31,1.31,0,0,0,1.46-.13l3.09-2.55-2.59,9a1.61,1.61,0,0,0-.08.61h0a2.06,2.06,0,0,0,1.18,1.81l0,0,9.27,4.5h0a2,2,0,0,0,1,.39l5.36.67a3.38,3.38,0,0,0,3.5-2l4.56-10.18a5.31,5.31,0,0,1,2.22-2.42l.23.67a1.61,1.61,0,0,0,1,1h0l9.42,4.62,0,0,0,0h0a1.6,1.6,0,0,0,1.77-.27l8.2-7.5A4.13,4.13,0,0,0,95,212.48l-1.17-8.2a5.85,5.85,0,0,1,.88-4l3.75-5.8a5.25,5.25,0,0,1,4.41-2.4h5a3,3,0,0,0,2.8-2L115.22,178a2.48,2.48,0,0,0-1.08-3h0l-.06,0-.18-.09-6.28-3.06a2.43,2.43,0,0,1-.08-.81Zm-30.1-5.87a16.41,16.41,0,0,1,6.71-3,17.32,17.32,0,0,1,1.81,6.59c1,11-5.45,25-14.45,31.43a17.25,17.25,0,0,1-6.6,3,16.77,16.77,0,0,1-1.91-6.66C62.44,179.34,68.91,165.27,77.91,158.89Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.88,195.44,41.52,206,32,201a4.41,4.41,0,0,1,1-1.78L40,192a4.82,4.82,0,0,0,1-1.58Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.42,164.45l-.21,1.18h-9l-8.84-5a3.17,3.17,0,0,1,.93-.13h5.23a3.76,3.76,0,0,0,2.21-.71Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.63,133.51l-4,4h0l-7.17,7.05-9.49-5.24v0a5.08,5.08,0,0,1,1.22-2l8.06-8.15a1.61,1.61,0,0,1,1.74-.36h0l.3.14Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,126.45H93.54l-9.4-5h0a2.89,2.89,0,0,1,2.34-.75l6.15.78a2,2,0,0,1,.76.25h0Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.12,160.1l6.76-6.82a4.4,4.4,0,0,0,1.17-3.95l-1.71-8.24a1.69,1.69,0,0,0-2.73-1l-7,5.77a1.87,1.87,0,0,1-2.54-.15l-2-2.1a5,5,0,0,1-1.14-5l3.16-9.6a2.16,2.16,0,0,0-1.78-2.82l-6.15-.77a2.92,2.92,0,0,0-3,1.72l-4.55,10.38a5.43,5.43,0,0,1-2.85,2.81l-4.09,1.73A1.94,1.94,0,0,1,79,141l-2.55-6.61a1.63,1.63,0,0,0-2.67-.56L65.75,142a4.94,4.94,0,0,0-1.37,4.23l1.15,7.42a3.81,3.81,0,0,1-.56,2.63l-4.58,7.15a3.8,3.8,0,0,1-3.22,1.76H52a3.61,3.61,0,0,0-3.38,2.37L44,180.14a2,2,0,0,0,1.27,2.54L50,184.14a2.48,2.48,0,0,1,1.75,2.66L51,193.87a4.88,4.88,0,0,1-1.36,2.89l-7,7.22a4.36,4.36,0,0,0-1.14,4l2,9a1.31,1.31,0,0,0,2.11.73L52.47,212a2.68,2.68,0,0,1,3.78.37L58,214.51a4.13,4.13,0,0,1,.77,3.75L55.7,228.81a2.06,2.06,0,0,0,1.72,2.61l5.36.67a3.38,3.38,0,0,0,3.5-2l4.56-10.18a5.32,5.32,0,0,1,2.58-2.63l4-1.9a2.47,2.47,0,0,1,3.4,1.41l2.11,6.09a1.62,1.62,0,0,0,2.62.66l8.2-7.5A4.13,4.13,0,0,0,95,212.48l-1.17-8.2a5.85,5.85,0,0,1,.88-4l3.75-5.8a5.25,5.25,0,0,1,4.41-2.4h5a3,3,0,0,0,2.8-2L115.22,178a2.49,2.49,0,0,0-1.68-3.26l-4.12-1.11a2.51,2.51,0,0,1-1.86-2.61l.45-6.21A7.32,7.32,0,0,1,110.12,160.1ZM81.61,198.66c-9,6.38-17.12,2.64-18.14-8.34s5.44-25,14.44-31.43,17.12-2.64,18.15,8.34S90.61,192.28,81.61,198.66Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.55,60.74a6,6,0,0,1,1.74-3.84l5.57-5.63a3.55,3.55,0,0,0,1-3.25l-1.41-6.79a1.36,1.36,0,0,0-.71-.94h0l-7.9-3.86-.19-.09a1.37,1.37,0,0,0-1.39.21l-2.3,1.89,2.35-7.13a1.77,1.77,0,0,0-.91-2.14h0l-7.89-3.86h0a1.66,1.66,0,0,0-.63-.2l-5.07-.64a2.38,2.38,0,0,0-1.93.62h0a2.26,2.26,0,0,0-.57.79l-3.76,8.56a4.33,4.33,0,0,1-1.72,2l-.27-.7a1.26,1.26,0,0,0-.7-.73h0l-7.76-3.78-.25-.13h0a1.31,1.31,0,0,0-1.43.3l-6.65,6.72a4.14,4.14,0,0,0-1,1.66,4.28,4.28,0,0,0-.13,1.82l1,6.12a3.07,3.07,0,0,1-.46,2.17l-3.78,5.9a2.9,2.9,0,0,1-.81.86,3.14,3.14,0,0,1-1.83.59h-4.31a2.86,2.86,0,0,0-.77.1,3,3,0,0,0-2,1.84L97.8,69.53a1.61,1.61,0,0,0,.72,2h0l0,0,5.63,2.75a2.4,2.4,0,0,1,.06.76l-.64,5.83a3.66,3.66,0,0,1-.28,1.08,3.88,3.88,0,0,1-.84,1.3l-5.78,6a3.61,3.61,0,0,0-.86,1.47,3.55,3.55,0,0,0-.07,1.83l1.63,7.4a1.08,1.08,0,0,0,.62.75h0l7.85,3.85h0a1.08,1.08,0,0,0,1.21-.11l2.55-2.1-2.14,7.39a1.73,1.73,0,0,0-.07.5h0a1.69,1.69,0,0,0,1,1.49l0,0,7.64,3.72h0a1.79,1.79,0,0,0,.79.32l4.42.55a2.77,2.77,0,0,0,2.88-1.62l3.77-8.39a4.36,4.36,0,0,1,1.82-2l.2.55a1.31,1.31,0,0,0,.8.81h0l7.76,3.8a.05.05,0,0,0,0,0l0,0h0a1.35,1.35,0,0,0,1.46-.22l6.75-6.19a3.34,3.34,0,0,0,1.06-3l-1-6.76a4.74,4.74,0,0,1,.72-3.28l3.09-4.78a4.33,4.33,0,0,1,3.64-2h4.11a2.46,2.46,0,0,0,2.31-1.61l3.73-10.06a2,2,0,0,0-.88-2.47h0l-.05,0-.15-.08-5.18-2.52a2.5,2.5,0,0,1-.06-.67ZM133.73,55.9a13.63,13.63,0,0,1,5.54-2.44,14.5,14.5,0,0,1,1.49,5.43c.84,9-4.49,20.65-11.91,25.91a14.16,14.16,0,0,1-5.44,2.51,13.72,13.72,0,0,1-1.58-5.5C121,72.76,126.31,61.16,133.73,55.9Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.55,60.74a6,6,0,0,1,1.74-3.84l5.57-5.63a3.55,3.55,0,0,0,1-3.25l-1.41-6.79a1.36,1.36,0,0,0-.71-.94h0l-7.9-3.86-.19-.09a1.37,1.37,0,0,0-1.39.21l-2.3,1.89,2.35-7.13a1.77,1.77,0,0,0-.91-2.14h0l-7.89-3.86h0a1.66,1.66,0,0,0-.63-.2l-5.07-.64a2.38,2.38,0,0,0-1.93.62h0a2.26,2.26,0,0,0-.57.79l-3.76,8.56a4.33,4.33,0,0,1-1.72,2l-.27-.7a1.26,1.26,0,0,0-.7-.73h0l-7.76-3.78-.25-.13h0a1.31,1.31,0,0,0-1.43.3l-6.65,6.72a4.14,4.14,0,0,0-1,1.66,4.28,4.28,0,0,0-.13,1.82l1,6.12a3.07,3.07,0,0,1-.46,2.17l-3.78,5.9a2.9,2.9,0,0,1-.81.86,3.14,3.14,0,0,1-1.83.59h-4.31a2.86,2.86,0,0,0-.77.1,3,3,0,0,0-2,1.84L97.8,69.53a1.61,1.61,0,0,0,.72,2h0l0,0,5.63,2.75a2.4,2.4,0,0,1,.06.76l-.64,5.83a3.66,3.66,0,0,1-.28,1.08,3.88,3.88,0,0,1-.84,1.3l-5.78,6a3.61,3.61,0,0,0-.86,1.47,3.55,3.55,0,0,0-.07,1.83l1.63,7.4a1.08,1.08,0,0,0,.62.75h0l7.85,3.85h0a1.08,1.08,0,0,0,1.21-.11l2.55-2.1-2.14,7.39a1.73,1.73,0,0,0-.07.5h0a1.69,1.69,0,0,0,1,1.49l0,0,7.64,3.72h0a1.79,1.79,0,0,0,.79.32l4.42.55a2.77,2.77,0,0,0,2.88-1.62l3.77-8.39a4.36,4.36,0,0,1,1.82-2l.2.55a1.31,1.31,0,0,0,.8.81h0l7.76,3.8a.05.05,0,0,0,0,0l0,0h0a1.35,1.35,0,0,0,1.46-.22l6.75-6.19a3.34,3.34,0,0,0,1.06-3l-1-6.76a4.74,4.74,0,0,1,.72-3.28l3.09-4.78a4.33,4.33,0,0,1,3.64-2h4.11a2.46,2.46,0,0,0,2.31-1.61l3.73-10.06a2,2,0,0,0-.88-2.47h0l-.05,0-.15-.08-5.18-2.52a2.5,2.5,0,0,1-.06-.67ZM133.73,55.9a13.63,13.63,0,0,1,5.54-2.44,14.5,14.5,0,0,1,1.49,5.43c.84,9-4.49,20.65-11.91,25.91a14.16,14.16,0,0,1-5.44,2.51,13.72,13.72,0,0,1-1.58-5.5C121,72.76,126.31,61.16,133.73,55.9Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.28,86l-8.55,8.68-7.89-4.07a3.61,3.61,0,0,1,.86-1.47l5.78-6a3.88,3.88,0,0,0,.84-1.3Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.49,60.49l-.17,1h-7.41l-7.29-4.16a2.86,2.86,0,0,1,.77-.1h4.31a3.14,3.14,0,0,0,1.83-.59Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.86,35l-3.34,3.29h0l-5.91,5.82-7.83-4.32v0a4.14,4.14,0,0,1,1-1.66l6.65-6.72a1.31,1.31,0,0,1,1.43-.3h0l.25.13Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.4,29.16h-7.78l-7.75-4.09h0a2.38,2.38,0,0,1,1.93-.62l5.07.64a1.66,1.66,0,0,1,.63.2h0Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.29,56.9l5.57-5.63a3.55,3.55,0,0,0,1-3.25l-1.41-6.79a1.39,1.39,0,0,0-2.24-.8l-5.79,4.76a1.56,1.56,0,0,1-2.1-.12l-1.66-1.73a4.09,4.09,0,0,1-1-4.12l2.61-7.92A1.78,1.78,0,0,0,153.81,29l-5.07-.64a2.39,2.39,0,0,0-2.5,1.41l-3.75,8.57a4.46,4.46,0,0,1-2.35,2.31l-3.37,1.43a1.6,1.6,0,0,1-2.11-.9l-2.11-5.45a1.34,1.34,0,0,0-2.2-.46L123.71,42a4.07,4.07,0,0,0-1.13,3.49l.94,6.12a3.12,3.12,0,0,1-.45,2.17l-3.78,5.9a3.16,3.16,0,0,1-2.65,1.45h-4.31A3,3,0,0,0,109.54,63l-3.8,10.38a1.62,1.62,0,0,0,1,2.1l4,1.2a2.06,2.06,0,0,1,1.45,2.19l-.64,5.83a4,4,0,0,1-1.12,2.38l-5.78,5.95a3.64,3.64,0,0,0-.93,3.3l1.63,7.4a1.08,1.08,0,0,0,1.74.6l5.68-4.68a2.2,2.2,0,0,1,3.11.31l1.44,1.76a3.38,3.38,0,0,1,.63,3.09l-2.51,8.7a1.69,1.69,0,0,0,1.41,2.15l4.42.55a2.77,2.77,0,0,0,2.88-1.62l3.77-8.39a4.37,4.37,0,0,1,2.12-2.18l3.29-1.56a2,2,0,0,1,2.8,1.17l1.75,5a1.33,1.33,0,0,0,2.16.55l6.75-6.19a3.34,3.34,0,0,0,1.06-3l-1-6.76a4.74,4.74,0,0,1,.72-3.28l3.09-4.78a4.33,4.33,0,0,1,3.64-2h4.11a2.46,2.46,0,0,0,2.31-1.61l3.73-10.06a2,2,0,0,0-1.38-2.69l-3.4-.91a2.09,2.09,0,0,1-1.53-2.16l.37-5.12A6,6,0,0,1,160.29,56.9Zm-23.5,31.79c-7.42,5.26-14.12,2.18-15-6.88s4.48-20.65,11.9-25.91,14.12-2.18,15,6.88S144.21,83.43,136.79,88.69Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.92,277.25l-4.06-2.72h0l-7.19,18.73L295,297.41l-1.82-2.63,9.16-18.55-4.06-2.73c-.36.18-.72.36-1.07.57-8.44,4.86-15.29,16.69-15.3,26.43,0,4.51,1.45,7.79,3.86,9.51l.41.27,3.23,2.13,1.1.75-.11,85.2c-5.11,5.79-8.64,13.85-8.65,20.84,0,3.67,1,6.52,2.62,8.38v0l4.07,2.73L287.66,419l3.91-10.19,1.47-.79,6.2-3.36,3.94,5.71-4.3,10.83L296,428.6l4.07,2.73,3.42-8.63c5.23-5.81,8.87-14,8.88-21.09A14.16,14.16,0,0,0,310.9,395l1.51-.23-3.82-2.55h0a7.76,7.76,0,0,0-5-1.5l.11-86.79c5.18-5.8,8.78-14,8.79-21,0-.59,0-1.14-.08-1.68Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.64,393.43l.11-86.79c5.19-5.81,8.79-13.95,8.8-21,0-3.67-1-6.51-2.63-8.38L306.73,296l-7.65,4.16-3.95-5.72,7.22-18.19c-.35.18-.71.36-1.06.57-8.44,4.86-15.3,16.69-15.31,26.43,0,7,3.5,11,8.61,10.91l-.11,86.94c-5.11,5.8-8.64,13.86-8.65,20.85,0,3.67,1,6.51,2.62,8.38l7.19-18.73,7.66-4.16,3.95,5.72L300,431.33c.35-.18.7-.36,1.06-.57,8.44-4.86,15.29-16.69,15.3-26.43C316.4,397.28,312.82,393.26,307.64,393.43Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.39,394.74h0l-3.82-2.55h0a7.23,7.23,0,0,0-.95-.6v1.83A7.81,7.81,0,0,1,312.39,394.74Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.39,394.74h0l-3.82-2.55h0a7.23,7.23,0,0,0-.95-.6v1.83A7.81,7.81,0,0,1,312.39,394.74Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.36 398.27 286.16 388.71 282.21 382.99 280.62 383.85 282.09 385.98 277.79 396.81 274.87 404.17 278.94 406.9 282.36 398.27 282.36 398.27",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.19,310.28l3.23,2.13.06,0c-2.19-1.79-3.51-4.95-3.5-9.22,0-9.74,6.87-21.57,15.31-26.43.35-.21.71-.39,1.06-.57h0l-4.06-2.73c-.36.18-.72.36-1.07.57-8.44,4.86-15.29,16.69-15.3,26.43,0,4.51,1.45,7.79,3.86,9.51Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.77 250.09 281.58 268.82 285.64 271.55 292.83 252.82 288.77 250.09",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.58 268.82 285.64 271.55 277.99 275.7 275.51 272.12 281.58 268.82",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.59,314.14a7.91,7.91,0,0,1-4.14-1l.07,0-.11,85.2,4.07,2.72Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.76,419.2c0,3.67,1,6.52,2.62,8.38v0l4.07,2.73c-1.66-1.87-2.63-4.71-2.62-8.38,0-7,3.54-15.05,8.65-20.85l-4.07-2.72C285.3,404.15,281.77,412.21,281.76,419.2Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.09 385.98 286.16 388.71 282.21 382.99 280.62 383.85 282.09 385.98",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.87 404.17 278.94 406.9 286.16 388.71 282.09 385.98 274.87 404.17",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.06,431s-3.79-3.24-5.26-3.4-4,2.37-1.87,6.75c.6,1.21,3,2.53,4.55,4.86s2.89,4.09,5.22,3.77,2.64-1.64,2.49-3.16a35.22,35.22,0,0,0-.84-4.13Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.83,442.28c-2.4.33-3.82-1.48-5.38-3.88s-4.08-3.76-4.7-5a9.33,9.33,0,0,1-.6-1.56,7.85,7.85,0,0,0,.78,2.53c.6,1.21,3,2.53,4.55,4.86s2.89,4.09,5.22,3.77c1.79-.25,2.38-1.08,2.5-2.14A2.67,2.67,0,0,1,283.83,442.28Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,435.17a.39.39,0,0,1-.18,0,.38.38,0,0,1-.15-.5,5.89,5.89,0,0,1,3.56-2.79.37.37,0,1,1,.17.71,5.28,5.28,0,0,0-3.08,2.43A.37.37,0,0,1,279,435.17Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.62,433.87a.34.34,0,0,1-.17-.05.36.36,0,0,1-.15-.5,5.93,5.93,0,0,1,3.56-2.79.38.38,0,0,1,.44.28.37.37,0,0,1-.28.44,5.21,5.21,0,0,0-3.07,2.42A.38.38,0,0,1,277.62,433.87Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,432.56a.38.38,0,0,1-.17,0,.37.37,0,0,1-.15-.5,5.93,5.93,0,0,1,3.56-2.79.37.37,0,1,1,.16.72,5.25,5.25,0,0,0-3.07,2.42A.37.37,0,0,1,276,432.56Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.9,441.63s-5.07-1.64-6.58-1.19-3,4,.92,7.43c1.1.95,4,1.25,6.5,2.93s4.53,2.85,6.7,1.57,2-2.73,1.61-4.32c-.49-2-.89-3.5-.89-3.5Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.28,451.63c-2.24,1.31-4.37.11-6.91-1.62s-5.57-2-6.7-3a10.58,10.58,0,0,1-1.24-1.3,8.59,8.59,0,0,0,1.81,2.18c1.1.95,4,1.25,6.5,2.93s4.53,2.85,6.7,1.57c1.67-1,1.91-2,1.59-3.13C270,450.07,269.57,450.88,268.28,451.63Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.69,446.32h0a.36.36,0,0,1-.33-.4,6.31,6.31,0,0,1,2.35-4.21.38.38,0,0,1,.52.09.36.36,0,0,1-.09.51,5.66,5.66,0,0,0-2.05,3.68A.37.37,0,0,1,259.69,446.32Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.79,447h0a.37.37,0,0,1-.33-.4,6.31,6.31,0,0,1,2.36-4.2.36.36,0,0,1,.51.08.38.38,0,0,1-.08.52,5.57,5.57,0,0,0-2,3.67A.38.38,0,0,1,261.79,447Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.76,445.61h0a.37.37,0,0,1-.33-.4,6.31,6.31,0,0,1,2.36-4.2.37.37,0,0,1,.52.09.38.38,0,0,1-.09.51,5.6,5.6,0,0,0-2.05,3.67A.37.37,0,0,1,257.76,445.61Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.83,341.88l4,4.2,7-6.91v-7.26s3,3.74,3,7.52-1,4.46-2.12,6.65-5.56,11-8.61,9.09a107.23,107.23,0,0,1-9-7.2Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.06,329s2.51,0,5.63,3.65,8.36,9.5,8.36,9.5a8,8,0,0,1-6,7.68l-7.3-6.27Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.06,329s2.51,0,5.63,3.65,8.36,9.5,8.36,9.5a8,8,0,0,1-6,7.68l-7.3-6.27Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.59,432c.45-5,1.44-12.9,1.85-16.58a47.57,47.57,0,0,0-.4-14,11.43,11.43,0,0,1-.16-3.3c1-10,1.65-26.23,1.1-29.8l-14.05,3s1.72,22.75,2.47,30.32S280,432,280,432A5.09,5.09,0,0,0,285.59,432Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.57,437.13a2.65,2.65,0,0,0,1.78-1.44c0-.79.09-2.12.24-3.72a5.09,5.09,0,0,1-5.6.06l.5,4.23A3.62,3.62,0,0,0,283.57,437.13Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.79,440.8c.57-7.61,1.68-22.35,1.82-24.66a36.76,36.76,0,0,0-.48-7.65,11.7,11.7,0,0,1,0-4.13l6.17-34.25-17-.25-1.11,35.89a9.28,9.28,0,0,0,.05,1.39l3.6,33.44h0S266.4,443.53,269.79,440.8Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,447.08a3.21,3.21,0,0,0,2.49-1.75l.35-4.53c-3.39,2.73-6.9-.22-6.9-.22h0l.54,5S264.23,447.33,267,447.08Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.19,331.29l-4,1.37L259.88,353l.21,18.07s3.08,2.45,15.09,2.45c6.75,0,11.14-2.54,12.8-5.25L286.9,357.4S288,346.64,288,341.32s.24-9.67-3.92-12.31l-3.7.3Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.19,331.29l-4,1.37L259.88,353l.21,18.07s3.08,2.45,15.09,2.45c6.75,0,11.14-2.54,12.8-5.25L286.9,357.4S288,346.64,288,341.32s.24-9.67-3.92-12.31l-3.7.3Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.84,313.78l-2,4a.45.45,0,0,0,.26.63l2.38.79Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.62,307.12s-3,1.64-3,11c0,5.17.36,8.47,3,8.26S277,325.21,277,325.21V307.12Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.62,326.42c.95-.07,2.51-.24,4.15-.43v-1a21.7,21.7,0,0,1-4.6,1.39A2.26,2.26,0,0,0,266.62,326.42Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.22 300.2 249.22 306.1 257.29 306.1 257.29 297.81 249.22 300.2",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.31,328.28a12.42,12.42,0,0,0,5.23.63c2.34-.41,2.84-1.83,2.84-1.83s.76-.05,2,2.23a5.93,5.93,0,0,1-4.72,3,18.23,18.23,0,0,1-7.45-1.06S269.32,328,270.31,328.28Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.31,328.28a12.42,12.42,0,0,0,5.23.63c2.34-.41,2.84-1.83,2.84-1.83s.76-.05,2,2.23a5.93,5.93,0,0,1-4.72,3,18.23,18.23,0,0,1-7.45-1.06S269.32,328,270.31,328.28Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.93,358.48l-3.21-2a.5.5,0,0,1,0-.85l14.12-8.28a1.17,1.17,0,0,1,1.21,0l17.6,11.07a.92.92,0,0,1,0,1.58l-14.52,8a1.38,1.38,0,0,1-1.44-.07Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.93,357.72l-3.21-2a.5.5,0,0,1,0-.85l14.12-8.28a1.19,1.19,0,0,1,1.21,0l17.6,11.08a.92.92,0,0,1,0,1.58l-14.52,8a1.36,1.36,0,0,1-1.44-.08Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.4 329.5 206.4 330.81 208.63 330.81 206.4 329.5",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.93,356.48l-3.21-2.05a.49.49,0,0,1,0-.84l14.12-8.28a1.17,1.17,0,0,1,1.21,0l17.6,11.08a.92.92,0,0,1,0,1.58l-14.52,8a1.36,1.36,0,0,1-1.44-.07Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.32,354.07a.36.36,0,0,1-.32-.18.35.35,0,0,1,.13-.5l9.63-5.65a.37.37,0,0,1,.5.13.38.38,0,0,1-.13.51L233.5,354A.31.31,0,0,1,233.32,354.07Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.68,355.61a.38.38,0,0,1-.32-.18.36.36,0,0,1,.13-.51l9.63-5.64a.35.35,0,0,1,.5.13.37.37,0,0,1-.13.5l-9.63,5.65A.41.41,0,0,1,235.68,355.61Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,357.14a.36.36,0,0,1-.32-.18.37.37,0,0,1,.13-.51l9.63-5.64a.35.35,0,0,1,.5.13.37.37,0,0,1-.13.5l-9.63,5.65A.41.41,0,0,1,238,357.14Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.4,358.67a.36.36,0,0,1-.32-.18.37.37,0,0,1,.13-.5l9.63-5.65a.37.37,0,0,1,.5.13.38.38,0,0,1-.13.51l-9.63,5.64A.31.31,0,0,1,240.4,358.67Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.76,360.21a.37.37,0,0,1-.19-.69l9.63-5.64a.35.35,0,0,1,.5.13.36.36,0,0,1-.13.5l-9.63,5.65A.37.37,0,0,1,242.76,360.21Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.08,349.91,254,357.14s-3.31,1-7,2.2a41.58,41.58,0,0,1-6.92,1.65,23.59,23.59,0,0,1-1.82-2.51c-.58-1-1.07-2.48-1.53-2s-1.14,2.08,0,4.54a4.74,4.74,0,0,1-2.5-.33,39,39,0,0,1-3.33-2.18s-.88,2.38,0,3.75,3.48,3.35,9.33,3.35,19.32-1.14,20.53-3.2,3.42-11.78,3.42-11.78Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.19,332.66s3.87,1.57,3.51,7.44-3.51,13.8-3.51,13.8-5.9,0-9.34-3.68l3.46-12.72a6,6,0,0,1,3.61-4C262.55,333.24,263.3,333,264.19,332.66Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#3F3A59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.19,332.66s3.87,1.57,3.51,7.44-3.51,13.8-3.51,13.8-5.9,0-9.34-3.68l3.46-12.72a6,6,0,0,1,3.61-4C262.55,333.24,263.3,333,264.19,332.66Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.46,301.58s-3.19-.42-4,1.78c-.51,1.37,1.12,2.43,1.12,2.43s-2.06,1.94,1,2.54a2,2,0,0,0,2.48,2.28s-.35,2.09,2.34,2.82c0,0-1.36,3.62,1.19,3.67H272l-1,2.78a7.81,7.81,0,0,0,7.36,4.31,36.42,36.42,0,0,1,2.08-3.8c.66-.86,4.11-5.27,4.11-8.77s-1.35-5.57-3.21-6a8,8,0,0,0-2.67-3.19c-1.88-1.27-5.83-2.4-8.06-.85,0,0-2-2.59-3.35-2.59S265.46,300.37,265.46,301.58Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.59,317.1s-.23-3.67,2.86-3.67,2.36,6.45-1.43,6.45Z",
    transform: "translate(-21.09 -24.43)",
    style: {
      fill: "#ffa8a7"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceImage);
export default __webpack_public_path__ + "static/media/maintenance-image.35e9da802471f838870ee0fbb77e7467.svg";
export { ForwardRef as ReactComponent };